import {signInTypes} from "../../../actions/AuthActions/AuthActionsTypes/SignInActionsTypes";

const initState = {};

const SignInErrorReducer = (state = initState, action) => {
    switch (action.type) {
        case signInTypes.SET_ERROR: {
            return Object.assign({}, state, {
                [action.name]: action.message,
            });
        }

        case signInTypes.REMOVE_ERRORS: {
            return initState;
        }

        default: {
            return state;
        }
    }
};

export default SignInErrorReducer;
